import React, { useEffect, useState } from "react"
import { Col } from "react-bootstrap"
import { injectIntl } from "react-intl"
import { useSelector } from "react-redux"
import IntlProps from "../../../state/helpers/IntlProps"
import { InventoryProductReorderResult } from "../../../state/inventory/data/model/inventoryData"
import { Service } from "../../../state/inventory/data/service"
import { NormalizedLocation } from "../../../state/inventory/location/reducers"
import { InventoryLocationSelector } from "../../../state/inventory/location/selectors"
import { REORDER_BANNER_MESSAGES } from "../../../utils/inventory"
import { ReorderProductsModal } from "../../modals/ReorderProductsModal"


export const ReorderBanner = injectIntl((props: IntlProps) => {
    const locationListing = useSelector(InventoryLocationSelector.getListing)
    const [showModal, setShowModal] = React.useState(false)
    const [reorderObjects, setReorderObjects] = useState<InventoryProductReorderResult[]>([])
    const [selectedReorderItem, setSelectedReorderItem] = useState<InventoryProductReorderResult>()
    
    const onClick = (item: InventoryProductReorderResult) => {
        setSelectedReorderItem(item)
        setShowModal(true)
    }

    useEffect(() => {
        const fetchData = (location: NormalizedLocation) => {
            return Service.findReorderItemsForLocationID(location.id)
                .then((res) => {
                    if (res) {
                        const locationProduct: InventoryProductReorderResult = {
                            productsForReorder: res,
                            locationId: location.id,
                            amountForReorder: res.length,
                            locationName: location.name,
                        }
                        return locationProduct
                    } else {
                        return {
                            productsForReorder: [],
                            locationId: location.id,
                            amountForReorder: 0,
                            locationName: location.name,
                        }
                    }
                })
        }
        const fetchDataForAllLocations = () => {
            if (locationListing && locationListing.length > 0) {
                const promises = locationListing.map((location) => fetchData(location))
    
                Promise.all(promises)
                    .then((results) => {
                        const nonEmptyResults = results.filter((result) => result.amountForReorder  > 0)
                        setReorderObjects((prevReorderObject) => [...prevReorderObject, ...nonEmptyResults])
                    
                    })
            }
        }

        fetchDataForAllLocations()
        
    },[locationListing.length])


    return (
        <Col>
            {reorderObjects.map((item, index) => (
                <div key={index} className="alert alert-primary ui-has-modules row" role="alert">
                    <Col sm="4">
                        {props.intl.formatMessage(REORDER_BANNER_MESSAGES["productText"],{
                            amount: item.amountForReorder
                        })}   
                    </Col>

                    <Col sm="8">
                        <span
                            style={{ cursor: "pointer", textDecoration: "underline", color: "blue" }}
                            onClick={() => onClick(item)}
                        >
                            {props.intl.formatMessage(REORDER_BANNER_MESSAGES["quickReorderText"], {
                                location: item.locationName
                            })}
                        </span>
                    </Col>
                </div>
            ))}

            {showModal && (
                <ReorderProductsModal 
                    reorderDetails = {selectedReorderItem}
                    onCloseCallback={() => setShowModal(false)} />
            )}
        </Col>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/sections/control/ReorderBanner.tsx